import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/signature-journeys/[id]/page.tsx");
